export default __webpack_public_path__ + "static/media/video_culture.a7db1f3f.png";